import videojs from "video.js";
import "./videojs-timeline-preview.scss";
import "./thumbnail.js";

const Plugin = videojs.getPlugin('plugin');

class TimelinePreview extends Plugin {
	constructor(player, options) {
		super(player, options);

		player.addClass('vjs-timeline-preview');

		player.ready(() => {
			const controlBar = player.getChild('ControlBar');
			const progressControl = controlBar && controlBar.getChild('ProgressControl');
			const seekBar = progressControl && progressControl.getChild('SeekBar');
			const mouseTimeDisplay = seekBar && seekBar.getChild('MouseTimeDisplay');
			const timeTooltip = mouseTimeDisplay && mouseTimeDisplay.getChild('TimeTooltip');
			if (!mouseTimeDisplay) return;
			progressControl.addChild(
				'TimelinePreviewImage',
				videojs.mergeOptions(options, { progressControl, timeTooltip, mouseTimeDisplay })
			);
			progressControl.on('mouseenter', () => {
				player.addClass('vjs-timeline-preview__thumbnail-show');
			});
			progressControl.on('mouseleave', () => {
				player.removeClass('vjs-timeline-preview__thumbnail-show');
			});
		});
	}
}

videojs.registerPlugin('timelinePreview', TimelinePreview);
